import { Controller } from "@hotwired/stimulus"
import { TempFormHelper } from "~/helpers/temp_form_helper"
import { CurrencyHelper } from "~/helpers/currency_helper"

// This controller is used to delete the selected leads.
export default class extends Controller {
  static get targets() {
    return ["dialogText"]
  }

  static get values() {
    return {
      filters: { type: Object, default: {} },
      numberOfLeads: { type: Number, default: 0 },
      selectedLeadIds: { type: Array, default: [] },
      totalCount: { type: Number, default: 0 },
    }
  }

  // This action submits a temporary form to delete the selected leads.
  submit() {
    let formToSubmit = TempFormHelper.create("/lead/bulk", "delete", (form) => {
      if (this.selectedLeadIdsValue.length > 0) {
        this.selectedLeadIdsValue.forEach((leadId) => {
          TempFormHelper.addHiddenInput(form, "lead_ids[]", leadId)
        })
      } else {
        Object.entries(this.filtersValue).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach((item) => {
              TempFormHelper.addHiddenInput(form, `${key}[]`, item)
            })
          } else {
            TempFormHelper.addHiddenInput(form, key, value)
          }
        })
      }
    })

    formToSubmit.dataset.confirmDialogId = "confirm-delete-leads"
    formToSubmit.dataset.turboConfirm = i18n.t("js.back.lead_actions.delete_leads")
    formToSubmit.requestSubmit()
  }

  // This action is used to update the selected leads value and update the text in the modal based on the number of
  // leads.
  // We trigger this using the check-all controller.
  updateSelection(event) {
    const allSelected = event.detail.allSelected

    if (allSelected) {
      this.selectedLeadIdsValue = []
    } else if (event.detail.dataSets) {
      this.selectedLeadIdsValue = event.detail.dataSets
        .map((dataSet) => dataSet.leadId || dataSet.recordId)
        .filter(Boolean)
    } else {
      this.selectedLeadIdsValue = []
    }

    const numberOfLeads = allSelected ? this.numberOfLeadsValue : this.selectedLeadIdsValue.length
    const leadName = numberOfLeads === 1 ? event.detail.dataSets[0]?.leadName : false
    if (leadName) {
      this.dialogTextTarget.innerHTML = i18n.t("js.back.lead_actions.delete_leads.description_with_name_html", {
        lead_name: leadName,
      })
    } else {
      this.dialogTextTarget.innerHTML = i18n.t("js.back.lead_actions.delete_leads.description_with_number_html", {
        lead_name: numberOfLeads,
        count: numberOfLeads,
        number_of_leads: CurrencyHelper.numberWithDelimiter(numberOfLeads),
      })
    }
  }
}
